import { Modal, ModalTitle, ModalBody, ModalFooter } from 'design-system/src/components/Modal';
import { Typography } from 'design-system/src/components/Typography/Typography';
import Button from 'design-system/src/components/Button/Button';
import { UseMutationResult } from '@tanstack/react-query';
export type CloseTaskConfirmationModalProps = {
  onCloseModal: () => void;
  closeTaskMutation: UseMutationResult<void, Error, void>;
};

/**
 * A modal asking the user to confirm that they want to cancel the task.
 */
export const CloseTaskConfirmationModal = ({ onCloseModal, closeTaskMutation }: CloseTaskConfirmationModalProps) => {
  return (
    <Modal onClose={onCloseModal}>
      <ModalTitle>Close task?</ModalTitle>

      <ModalBody>
        <Typography styledAs="bodySmallDMSans">
          Closing this task will move it to the closed tab. You can re-open this at any time by adding a comment. Tandem
          will send a new task if there are any further updates to share.
        </Typography>
      </ModalBody>

      <ModalFooter>
        <Button variant="tertiary" size="sm" onClick={onCloseModal} disabled={closeTaskMutation.isPending}>
          Cancel
        </Button>
        <Button size="sm" onClick={() => closeTaskMutation.mutate()} isLoading={closeTaskMutation.isPending}>
          Close task
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default CloseTaskConfirmationModal;
